<template>
  <div style="height:100%">
      <div class="startCon">
            <div class="btn_5 posi_1">路径规划</div>
            <div class="btn_1 posi_2">路径下发</div>
            <div class="btn_3 posi_3" @click="workStart">
                <img class="iconImg" src="../../images/all/icon_1.png" alt="">
                启动作业
            </div>
            <div class="btn_2 posi_4">
                <img class="iconImg" src="../../images/all/icon_2.png" alt="">
                停止作业
            </div>
      </div>
    
    <div>
        <div class="setTitle">
            <div class="titleIcon"></div>初压设置
        </div>
        <div class="goSpeedCon">
            <span class="text1">前进速度</span>
            <el-input @input="change($event)" type="text" placeholder="最小值" v-model="mixSpeed"></el-input>
            <span class="text2">-</span>
            <el-input placeholder="最大值"></el-input>
            <span class="text3">km/h</span>
            <div class="btn_6">设置</div>
        </div>
        <div class="backSpeedCon">
            <span class="text1">后退速度</span>
            <el-input placeholder="设置后退速度"></el-input>
            <span class="text3">km/h</span>
            <div class="btn_6">设置</div>
        </div>
        <div class="startCon">
            <div class="btn_1 posi_1">缩短初压安全限制</div>
            <div class="btn_4 posi_2">缩短初压安全限制</div>
            <div class="btn_2 posi_3">
                <img class="iconImg" src="../../images/all/icon_2.png" alt="">
                初压结束
            </div>
            <div class="btn_2 posi_4">
                <img class="iconImg" src="../../images/all/icon_3.png" alt="">
                初压继续
            </div>
        </div>
        <div class="setTitle">
            <div class="titleIcon"></div>复压设置
        </div>
        <div class="secondCon">
            <span class="text1">复压生成长度</span>
            <el-input placeholder="设置生成长度"></el-input>
            <span class="text3">M</span>
            <div class="btn_6">设置</div>
        </div>
        <div class="afterCon">
            <div class="btn_2 posi_1">
                <img class="iconImg" src="../../images/all/icon_2.png" alt="">
                复压结束
            </div>
            <div class="btn_2 posi_2">
                <img class="iconImg" src="../../images/all/icon_3.png" alt="">
                复压继续
            </div>
        </div>
        <div class="setTitle">
            <div class="titleIcon"></div>摊铺设置
        </div>
        <div class="afterCon">
            <div class="btn_2 posi_1">
                <img class="iconImg" src="../../images/all/icon_2.png" alt="">
                摊铺结束
            </div>
            <div class="btn_2 posi_2">
                <img class="iconImg" src="../../images/all/icon_3.png" alt="">
                摊铺继续
            </div>
        </div>
    </div>
    
  </div>
</template>

<script>
    export default {
        name      : 'app',
        mixins: [],
        data() {
            return {
                mixSpeed: ''
            }
        },
        props:{
            maskBackCode:{
                type: Number,
                default: function(){
                    return 0
                }
            }
        },
        computed:{

        },
        created(){

        },
        mounted(){
        },
        methods: {
            workStart: function(){
                //console.log(this.maskBackCode)
                
            },
            change(){
                //console.log(e)
                this.$forceUpdate()
            }
        },
        components:{
        }
    }
</script>
<style lang="scss">
    .goSpeedCon{
        .el-input{
            height: 28px;
            width: 60px;
            // margin-left: 10px;
            .el-input__inner{
                height: 28px !important;
                width: 60px !important;
                border-radius: 0;
            }
        }
    }
    .backSpeedCon{
        .el-input{
            height: 28px;
            width: 140px;
            // margin-left: 10px;
            .el-input__inner{
                height: 28px !important;
                width: 140px !important;
                border-radius: 0;
            }
        }
    }
    .secondCon{
        .el-input{
            height: 28px;
            width: 112px;
            // margin-left: 10px;
            .el-input__inner{
                height: 28px !important;
                width: 112px !important;
                border-radius: 0;
            }
        }
    }
</style>
<style lang="scss" scoped="">
    .startCon{
        width: 100%;
        height: 100px;
        position: relative;
    }
    .afterCon{
        width: 100%;
        height: 50px;
        position: relative;
    }
    .posi_1{
        position: absolute;
        top: 10px;
        left: 30px;
    }
    .posi_2{
        position: absolute;
        top: 10px;
        right: 30px;
    }
    .posi_3{
        position: absolute;
        top: 60px;
        left: 30px;
    }
    .posi_4{
        position: absolute;
        top: 60px;
        right: 30px;
    }
    .btn_1{
        height: 40px;
        width: 160px;
        background: #FCE8E8;
        border: 1px solid #E96B5A;
        border-radius: 2px;
        line-height: 38px;
        text-align: center;
        color: #E96B5A;
        font-size: 14px;
        cursor: pointer;
    }
    .btn_5{
        height: 40px;
        width: 160px;
        background: #E96B5A;
        border-radius: 2px;
        line-height: 40px;
        text-align: center;
        color: #ffffff;
        font-size: 14px;
        cursor: pointer;
    }
    .btn_2{
        height: 40px;
        width: 160px;
        background: #FCE8E8;
        border: 1px solid #E96B5A;
        border-radius: 2px;
        line-height: 38px;
        color: #E96B5A;
        font-size: 14px;
        padding-left: 59px;
        position: absolute;
        cursor: pointer;
        .iconImg{
            height: 16px;
            width: 16px;
            position: absolute;
            top: 11px;
            left: 35px;
        }
    }
    .btn_3{
        height: 40px;
        width: 160px;
        background: #E96B5A;
        border-radius: 2px;
        line-height: 38px;
        color: #ffffff;
        font-size: 14px;
        padding-left: 59px;
        position: absolute;
        cursor: pointer;
        .iconImg{
            height: 16px;
            width: 16px;
            position: absolute;
            top: 11px;
            left: 35px;
            
        }
    }
    .btn_4{
        height: 40px;
        width: 160px;
        background: #DDF0E5;
        border: 1px solid #B6E0C8;
        border-radius: 2px;
        line-height: 38px;
        text-align: center;
        color: #10C766;
        font-size: 14px;
        cursor: pointer;
    }

    .setTitle{
        height: 16px;
        width: 100%;
        margin-top: 20px;
        position: relative;
        line-height: 16px;
        color: #555555;
        font-size: 14px;
        font-weight: 600;
        padding-left: 30px;
        .titleIcon{
            width: 4px;
            height: 16px;
            background-color: #E96B5A;
            position: absolute;
            top: 0;
            left: 20px;
        }
    }
    .secondCon{
        width: 100%;
        height: 28px;
        margin-top: 10px;
        font-size: 14px;
        color: #555555;
        line-height: 28px;
        .text1{
            display: inline-block;
            margin-left: 31px;
            margin-right: 10px;
        }
        .text2{
            display: inline-block;
            margin-left: 7px;
        }
        .text3{
            display: inline-block;
            margin-left: 11px;
        }
        .btn_6{
            height: 28px;
            width: 40px;
            background: #FCE8E8;
            border: 1px solid #E96B5A;
            border-radius: 2px;
            line-height: 28px;
            color: #E96B5A;
            font-size: 12px;
            text-align: center;
            cursor: pointer;
            float: right;
            margin-right: 29px;
        }
    }
    .backSpeedCon{
        width: 100%;
        height: 28px;
        margin-top: 10px;
        font-size: 14px;
        color: #555555;
        line-height: 28px;
        .text1{
            display: inline-block;
            margin-left: 31px;
            margin-right: 10px;
        }
        .text2{
            display: inline-block;
            margin-left: 7px;
        }
        .text3{
            display: inline-block;
            margin-left: 11px;
        }
        .btn_6{
            height: 28px;
            width: 40px;
            background: #FCE8E8;
            border: 1px solid #E96B5A;
            border-radius: 2px;
            line-height: 28px;
            color: #E96B5A;
            font-size: 12px;
            text-align: center;
            cursor: pointer;
            float: right;
            margin-right: 29px;
        }
    }
    .goSpeedCon{
        width: 100%;
        height: 28px;
        margin-top: 10px;
        font-size: 14px;
        color: #555555;
        line-height: 28px;
        .text1{
            display: inline-block;
            margin-left: 31px;
            margin-right: 10px;
        }
        .text2{
            display: inline-block;
            margin-left: 7px;
            margin-right: 8px;
        }
        .text3{
            display: inline-block;
            margin-left: 11px;
        }
        .btn_6{
            height: 28px;
            width: 40px;
            background: #FCE8E8;
            border: 1px solid #E96B5A;
            border-radius: 2px;
            line-height: 28px;
            color: #E96B5A;
            font-size: 12px;
            text-align: center;
            cursor: pointer;
            float: right;
            margin-right: 29px;
        }
    }
</style>